"use strict";

module.exports = and;

function and(a, b) {
  return Boolean(a && b);
}

;